//  学习动力
/*
    1.学习态度
*/
const Part2Index = () => import('@/views/ceping/LearningAbility/LearningMotivation/index.vue');
const LearningMotivationGuide1 = () => import('@/views/ceping/LearningAbility/LearningMotivation/quesGuide1')
const LearningMotivationQues1= () => import('@/views/ceping/LearningAbility/LearningMotivation/ques1')
const LearningMotivationSuccess1 = () => import('@/views/ceping/LearningAbility/LearningMotivation/quesSuccess1')

export default[
    {
        path: '/learningAbility/LearningMotivation',
        name: '学习动力首页',
        component:Part2Index,
        meta:{requireAuth:true,roles:['student']},
    },
    {
        path: '/learningAbility/LearningMotivation/guide/1',
        name: 'LearningMotivationGuide1',
        component: LearningMotivationGuide1,
        meta:{requireAuth:true,roles:['student']},
    },
    {
        path: '/learningAbility/LearningMotivation/1',
        name: 'LearningMotivationQues1',
        component: LearningMotivationQues1,
        meta:{requireAuth:true,roles:['student']},
    },
    {
        path: '/learningAbility/LearningMotivation/success/1',
        name: 'LearningMotivationSuccess1',
        component: LearningMotivationSuccess1,
        meta:{requireAuth:true,roles:['student']},
    },
]
